export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-4 animate-in fade-in slide-in-from-bottom-1 duration-300">
    <div>
      <h1 className="font-heading text-2xl font-semibold tracking-tight text-slate-100 sm:text-3xl">{title}</h1>
      {subtitle && <p className="mt-1 max-w-2xl text-sm text-slate-400">{subtitle}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const Panel = ({ title, action, children, className = "", testId }) => (
  <section data-testid={testId} className={`rounded-sm border border-slate-800 bg-[#252A35] ${className}`}>
    {title && (
      <div className="flex items-center justify-between border-b border-slate-800 px-5 py-3">
        <h2 className="font-mono text-[11px] uppercase tracking-widest text-slate-400">{title}</h2>
        {action}
      </div>
    )}
    {children}
  </section>
);

export const Th = ({ children, className = "" }) => (
  <th className={`whitespace-nowrap px-4 py-2.5 text-left font-mono text-[10px] font-medium uppercase tracking-wider text-slate-500 ${className}`}>
    {children}
  </th>
);

export const Td = ({ children, className = "", ...rest }) => (
  <td className={`px-4 py-3 text-xs text-slate-300 ${className}`} {...rest}>
    {children}
  </td>
);

export const Empty = ({ children, testId }) => (
  <div data-testid={testId} className="px-5 py-10 text-center text-sm text-slate-500">
    {children}
  </div>
);

export const btn = {
  primary: "bg-emerald-500 text-white hover:bg-emerald-600",
  ghost: "border border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800 hover:text-white",
  danger: "border border-rose-500/40 bg-transparent text-rose-300 hover:bg-rose-500/10 hover:text-rose-200",
};

export const field = "border-slate-700 bg-[#17191F] text-slate-100 placeholder:text-slate-600";
